import { AmplifyAuthService } from './awsAmplify';

export const CMAAuth = AmplifyAuthService();

export * from './types';
